import React, { useEffect, useState } from "react";
import ImageDiv from "./ImageDiv";
import LogInDiv from "./LogInDiv";
import railPariksha from "../../img/rp.png";
import wcr from "../../img/WCRInspect.png";
import "./Login.css";
const LogInForm = ({ inputFocus, setInputFocus }) => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 720);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 720);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  const handleClick = (e) => {
    e.stopPropagation();
    setInputFocus(true);
  };
  return (
    <div
      style={{
        background: "linear-gradient(to top, #cce1eaff, #ffffff)",
        borderRadius: "16px",
      }}
    >
      <div
        style={{
          fontSize: "12px",
          backdropFilter: "blur(10px)",
          WebkitBackdropFilter: "blur(10px)",
          background: "rgba(255, 255, 255, 0.1)",
          borderRadius: "16px",
          border: "1px solid rgba(161, 160, 160, 0.2)",
          boxShadow: "0 8px 32px 0 rgba(31, 38, 135, 0.37)",
          color: "#fff",
          padding: "8px",
          minHeight: "35vh",
          textAlign: "center",
        }}
      >
        <div className="row m-1" style={{ minWidth: "70vw", color: "black" }}>
          {!isMobile && (
            <div className="col-md-7 m-0 p-0">
              <div
                className="border"
                style={{
                  borderRadius: "8px 0px 0px 8px",
                  minHeight: "45vh",
                  borderRadius: "8px",
                  height: "100%",
                }}
              >
                <ImageDiv inputFocus={inputFocus} />
              </div>
            </div>
          )}
          <div
            className={`m-0 p-0 ${isMobile ? "col-md-12" : "col-md-5"}`}
            onClick={handleClick}
          >
            <div
              className=" d-flex align-items-center justify-content-center mx-auto"
              style={{
                borderRadius: isMobile ? "8px" : "0px 8px 8px 0px",
                // minHeight: "25vh",
              }}
            >
              <div className="px-4">
                <LogInDiv setInputFocus={setInputFocus} isMobile={isMobile} />
                {/* ///////////////////////////////////////////////////////////////////////////////////////////// */}
                {/* /////////////////////////////// OTHER PROJECT //////////////////////////////////// */}
                {/* ///////////////////////////////////////////////////////////////////////////////////////////// */}
                {/* </div> */}
                {/* Other Railway Systems */}
                {/* <div
                className="w-100 mt-4"
                style={{
                  maxWidth: "650px",
                }}
              > */}
                {/* Heading */}
                <div className="text-center mb-3">
                  <h6 className="fw-bold text-dark mb-1">
                    Visit Other Websites
                  </h6>

                  <p className="text-muted small mb-0">by DRM IT CELL</p>
                </div>

                {/* Cards */}
                {isMobile ? (
                  <div>
                    <a
                      href="http://89.116.34.79:5650"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-decoration-none"
                    >
                      <button className="main-btn text-white m-1">
                        {" "}
                        Rail Pariksha
                      </button>
                    </a>{" "}
                    <a
                      href="http://89.116.34.79:5040"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-decoration-none"
                    >
                      <button className="main-btn text-white m-1">
                        WCR Inspection
                      </button>
                    </a>
                  </div>
                ) : (
                  <div
                    className="d-grid gap-3"
                    style={{
                      gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
                    }}
                  >
                    {/* Rail Pariksha */}
                    <a
                      href="http://89.116.34.79:5650"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-decoration-none"
                    >
                      <div className="project-card">
                        {/* Image */}
                        <div className="project-card-image">
                          <img src={railPariksha} alt="Rail Pariksha" />

                          {/* Image Overlay */}
                          <div className="project-card-overlay">
                            <span className="project-badge">
                              Online examination
                            </span>
                          </div>
                        </div>

                        {/* Content */}
                        <div className="project-card-content">
                          <div>
                            <h6 className="project-card-title">
                              Rail Pariksha
                            </h6>

                            <p className="project-card-text">
                              Online examination and railway preparation
                              platform
                            </p>
                          </div>

                          <button
                            type="button"
                            className="main-btn text-white project-open-btn"
                          >
                            Open Site
                          </button>
                        </div>
                      </div>
                    </a>

                    {/* WCR Inspection */}
                    {/* WCR Inspection */}
                    <a
                      href="http://89.116.34.79:5040"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-decoration-none"
                    >
                      <div className="project-card">
                        {/* Image */}
                        <div className="project-card-image">
                          <img src={wcr} alt="WCR Inspection" />

                          <div className="project-card-overlay">
                            <span className="project-badge">
                              Inspection System
                            </span>
                          </div>
                        </div>

                        {/* Content */}
                        <div className="project-card-content">
                          <div>
                            <h6 className="project-card-title">
                              WCR Inspection
                            </h6>

                            <p className="project-card-text">
                              Railway inspection and monitoring dashboard
                            </p>
                          </div>

                          <span className="main-btn text-white project-open-btn d-flex align-items-center justify-content-center">
                            Open Site
                          </span>
                        </div>
                      </div>
                    </a>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LogInForm;
